export const privacyContent = {
    it: [
        {
            title: '1. Contesto del servizio',
            body: [
                'Foundly è un\'applicazione web per la scoperta musicale che suggerisce artisti e brani basandosi su input testuali e API esterne (Spotify, Deezer, Last.fm, Google Gemini AI).',
                'Il servizio è utilizzabile anche senza account. Gli utenti possono opzionalmente creare un account tramite Google OAuth per salvare i propri artisti preferiti e accedere a funzionalità personalizzate.'
            ]
        },
        {
            title: '2. Titolare del trattamento',
            body: [
                'Foundly Project Owner (progetto personale)',
                'Contatto principale: info@foundly.it',
                'Ulteriori recapiti possono essere forniti su richiesta motivata. Il sito è ospitato su IONOS (UE), che agisce come Responsabile esterno del trattamento.'
            ]
        },
        {
            title: '3. Dati Google a cui accediamo',
            body: [
                'Foundly accede ai seguenti dati utente Google tramite le API autorizzate:'
            ],
            bullets: [
                'Google OAuth 2.0: ID account Google, indirizzo email, nome visualizzato e immagine del profilo (avatar). Questi dati sono utilizzati esclusivamente per autenticare l\'utente e personalizzare l\'interfaccia.',
                'Google Gemini API: Foundly invia prompt testuali (richieste di raccomandazioni musicali) all\'API Gemini. Non accediamo a nessun dato personale dell\'utente tramite Gemini; l\'API riceve solo il testo della richiesta musicale e restituisce suggerimenti.',
                'Token di refresh OAuth: utilizzato per mantenere la sessione attiva senza richiedere login ripetuti.'
            ]
        },
        {
            title: '4. Finalità del trattamento dei dati Google',
            body: [
                'I dati Google vengono utilizzati esclusivamente per le seguenti finalità:'
            ],
            bullets: [
                'Autenticazione: verificare l\'identità dell\'utente tramite Google OAuth.',
                'Personalizzazione dell\'interfaccia: mostrare nome e avatar dell\'utente nel profilo.',
                'Sincronizzazione dei preferiti: associare gli artisti salvati all\'account dell\'utente.',
                'Raccomandazioni AI: inviare richieste testuali a Google Gemini per generare suggerimenti musicali personalizzati.'
            ],
            body2: [
                'I dati Google non vengono utilizzati per finalità pubblicitarie, profilazione commerciale, vendita a terzi o addestramento di modelli AI proprietari.'
            ]
        },
        {
            title: '5. Archiviazione dei dati Google',
            body: [
                'I dati Google degli utenti vengono archiviati nei seguenti luoghi:'
            ],
            bullets: [
                'Supabase (database cloud, server UE): ID account Google, email, nome, avatar URL e token OAuth criptati. Supabase agisce come Responsabile del trattamento con hosting esclusivamente nell\'Unione Europea.',
                'localStorage del browser (solo lato client): token di sessione temporanei per mantenere l\'autenticazione durante la navigazione. Questi dati rimangono sul dispositivo dell\'utente e non vengono trasmessi a server esterni.',
                'sessionStorage del browser: stato temporaneo della navigazione (es. risultati di ricerca correnti). Cancellato automaticamente alla chiusura del browser.'
            ],
            body2: [
                'Non vengono archiviati: password Google, contenuti di Gmail, Google Drive, Google Calendar o qualsiasi altro dato dell\'account Google non esplicitamente elencato sopra.'
            ]
        },
        {
            title: '6. Condivisione dei dati Google con terze parti',
            body: [
                'I dati Google vengono condivisi esclusivamente con i seguenti fornitori di servizi, strettamente necessari al funzionamento dell\'applicazione:'
            ],
            bullets: [
                'Supabase Inc. (hosting UE): storage del database e gestione autenticazione. Agisce come Responsabile del trattamento secondo le Clausole Contrattuali Standard (SCC).',
                'Google LLC: per l\'autenticazione OAuth e per le chiamate all\'API Gemini. I dati sono trattati secondo i Termini di Servizio delle API Google.',
                'Spotify, Deezer, Last.fm: Foundly riceve dati musicali (artisti, album, brani) da queste API. I dati Google non vengono condivisi con questi servizi.'
            ],
            body2: [
                'I dati Google non vengono condivisi con network pubblicitari, data broker, servizi di analytics di terze parti (ad eccezione di Google Analytics con IP anonimizzato) o altri utenti dell\'applicazione.'
            ]
        },
        {
            title: '7. Misure di sicurezza',
            bullets: [
                'Token OAuth criptati: i token di autenticazione Google sono criptati prima di essere salvati nel database.',
                'Connessioni HTTPS: tutte le comunicazioni tra l\'applicazione e i server avvengono tramite connessioni sicure TLS/SSL.',
                'Hosting UE: i server Supabase sono situati nell\'Unione Europea, garantendo conformità al GDPR.',
                'Accesso limitato agli scope: vengono richiesti solo gli scope OAuth strettamente necessari (profilo base e email).',
                'Nessun accesso a servizi Google non dichiarati: Gmail, Google Drive, Google Calendar, Google Photos o altri servizi Google.'
            ]
        },
        {
            title: '8. Conservazione e cancellazione dei dati',
            bullets: [
                'Dati account Google (email, nome, avatar): conservati fino alla cancellazione dell\'account o alla revoca dell\'accesso Google da parte dell\'utente.',
                'Token OAuth: conservati fino alla revoca dell\'accesso. Eliminati entro 24 ore dalla richiesta dell\'utente.',
                'Preferiti e liste salvate: conservati fino alla cancellazione dell\'account.',
                'Log tecnici: conservati per un massimo di 90 giorni, poi eliminati automaticamente.'
            ],
            body2: [
                'Per richiedere la cancellazione dei dati è possibile: inviare una email a info@foundly.it, revocare l\'accesso dalla dashboard utente dell\'applicazione, oppure revocare l\'accesso dalle impostazioni del proprio account Google all\'indirizzo https://myaccount.google.com/permissions.'
            ]
        },
        {
            title: '9. Diritti dell\'interessato',
            body: [
                'In conformità con il Regolamento (UE) 2016/679 (GDPR) e le policy di Google, l\'utente ha diritto a:'
            ],
            bullets: [
                'Accesso: richiedere una copia di tutti i dati Google conservati.',
                'Rettifica: correggere dati inesatti (nota: email e nome provengono da Google e si aggiornano automaticamente).',
                'Cancellazione: richiedere l\'eliminazione completa di tutti i dati entro 24 ore.',
                'Revoca: revocare l\'accesso di Foundly al proprio account Google in qualsiasi momento.',
                'Portabilità: richiedere i propri dati in formato leggibile.',
                'Reclamo: presentare reclamo al Garante per la protezione dei dati personali o all\'Autorità di controllo del proprio paese.'
            ],
            body2: [
                'Per esercitare questi diritti, scrivere a info@foundly.it. Il riscontro sarà fornito entro 30 giorni dalla richiesta.'
            ]
        },
        {
            title: '10. Base giuridica del trattamento',
            bullets: [
                'Art. 6, par. 1, lett. a) GDPR – Consenso: per la creazione dell\'account tramite Google OAuth e per i cookie non tecnici.',
                'Art. 6, par. 1, lett. b) GDPR – Esecuzione di un contratto: per fornire il servizio di raccomandazioni musicali e salvare i preferiti.',
                'Art. 6, par. 1, lett. f) GDPR – Legittimo interesse: per la sicurezza del servizio e la prevenzione di abusi.'
            ]
        },
        {
            title: '11. Cookie e tecnologie di tracciamento',
            bullets: [
                'Cookie tecnici: necessari per il funzionamento dell\'applicazione (sessione, preferenze lingua).',
                'Google Analytics 4: con IP anonimizzato e funzioni pubblicitarie disattivate. Caricato solo previo consenso dell\'utente.',
                'localStorage e sessionStorage: per memorizzare preferenze e stato della sessione lato client.',
                'Banner cookie: con opzioni "Accetta", "Rifiuta" e "Personalizza" al primo accesso.'
            ]
        },
        {
            title: '12. Trasferimenti internazionali di dati',
            body: [
                'I dati Google possono essere trasferiti verso:'
            ],
            bullets: [
                'Google LLC (USA): per OAuth e Gemini API, in conformità alle Clausole Contrattuali Standard approvate dalla Commissione Europea.',
                'Supabase Inc. (server UE): nessun trasferimento extra-UE per i dati archiviati.'
            ],
            body2: [
                'Non vengono effettuati trasferimenti verso paesi terzi in assenza di adeguate garanzie (Clausole Contrattuali Standard o decisioni di adeguatezza).'
            ]
        },
        {
            title: '13. Modifiche alla presente informativa',
            body: [
                'La presente informativa può essere aggiornata per adeguarsi a evoluzioni normative o all\'introduzione di nuove funzionalità. La data dell\'ultimo aggiornamento è indicata in cima alla pagina.',
                'Ultimo aggiornamento: Novembre 2025'
            ]
        }
    ],
    en: [
        {
            title: '1. Service overview',
            body: [
                'Foundly is a music-discovery web application that provides artist and track suggestions using third-party APIs (Spotify, Deezer, Last.fm, Google Gemini AI).',
                'The service can be used without an account. Users may optionally create an account via Google OAuth to save their favorite artists and access personalized features.'
            ]
        },
        {
            title: '2. Data Controller',
            body: [
                'Foundly Project Owner (personal project)',
                'Primary contact: info@foundly.it',
                'Additional contact details may be provided upon justified request. The application is hosted on IONOS (EU), acting as external Data Processor.'
            ]
        },
        {
            title: '3. Google data we access',
            body: [
                'Foundly accesses the following Google user data through authorized APIs:'
            ],
            bullets: [
                'Google OAuth 2.0: Google account ID, email address, display name, and profile picture (avatar). This data is used solely to authenticate the user and personalize the interface.',
                'Google Gemini API: Foundly sends text prompts (music recommendation requests) to the Gemini API. No personal user data is accessed through Gemini; the API only receives the music request text and returns suggestions.',
                'OAuth refresh token: used to maintain the active session without requiring repeated logins.'
            ]
        },
        {
            title: '4. Purposes of Google data processing',
            body: [
                'Google data is used exclusively for the following purposes:'
            ],
            bullets: [
                'Authentication: verify user identity through Google OAuth.',
                'Interface personalization: display user name and avatar in the profile.',
                'Favorites synchronization: associate saved artists with the user\'s account.',
                'AI recommendations: send text requests to Google Gemini to generate personalized music suggestions.'
            ],
            body2: [
                'Google data is not used for advertising purposes, commercial profiling, sale to third parties, or training proprietary AI models.'
            ]
        },
        {
            title: '5. Storage of Google data',
            body: [
                'Google user data is stored in the following locations:'
            ],
            bullets: [
                'Supabase (cloud database, EU servers): Google account ID, email, name, avatar URL, and encrypted OAuth tokens. Supabase acts as Data Processor with hosting exclusively in the European Union.',
                'Browser localStorage (client-side only): temporary session tokens to maintain authentication during browsing. This data remains on the user\'s device and is not transmitted to external servers.',
                'Browser sessionStorage: temporary navigation state (e.g., current search results). Automatically deleted when the browser is closed.'
            ],
            body2: [
                'The following are not stored: Google passwords, Gmail contents, Google Drive, Google Calendar, or any other Google account data not explicitly listed above.'
            ]
        },
        {
            title: '6. Sharing of Google data with third parties',
            body: [
                'Google data is shared exclusively with the following service providers, strictly necessary for application operation:'
            ],
            bullets: [
                'Supabase Inc. (EU hosting): database storage and authentication management. Acts as Data Processor under Standard Contractual Clauses (SCC).',
                'Google LLC: for OAuth authentication and Gemini API calls. Data is processed according to Google APIs Terms of Service.',
                'Spotify, Deezer, Last.fm: Foundly receives music data (artists, albums, tracks) from these APIs. Google data is not shared with these services.'
            ],
            body2: [
                'Google data is not shared with advertising networks, data brokers, third-party analytics services (except Google Analytics with anonymized IP), or other application users.'
            ]
        },
        {
            title: '7. Security measures',
            bullets: [
                'Encrypted OAuth tokens: Google authentication tokens are encrypted before being saved to the database.',
                'HTTPS connections: all communications between the application and servers use secure TLS/SSL connections.',
                'EU hosting: Supabase servers are located in the European Union, ensuring GDPR compliance.',
                'Limited scope access: only strictly necessary OAuth scopes are requested (basic profile and email).',
                'No access to undeclared Google services: Gmail, Google Drive, Google Calendar, Google Photos, or other Google services.'
            ]
        },
        {
            title: '8. Data retention and deletion',
            bullets: [
                'Google account data (email, name, avatar): retained until account deletion or Google access revocation by the user.',
                'OAuth tokens: retained until access revocation. Deleted within 24 hours upon user request.',
                'Favorites and saved lists: retained until account deletion.',
                'Technical logs: retained for a maximum of 90 days, then automatically deleted.'
            ],
            body2: [
                'To request data deletion, users may: send an email to info@foundly.it, revoke access from the application\'s user dashboard, or revoke access from their Google account settings at https://myaccount.google.com/permissions.'
            ]
        },
        {
            title: '9. Data subject rights',
            body: [
                'In compliance with Regulation (EU) 2016/679 (GDPR) and Google policies, users have the right to:'
            ],
            bullets: [
                'Access: request a copy of all stored Google data.',
                'Rectification: correct inaccurate data (note: email and name are provided by Google and update automatically).',
                'Erasure: request complete deletion of all data within 24 hours.',
                'Revocation: revoke Foundly\'s access to their Google account at any time.',
                'Portability: request data in a readable format.',
                'Complaint: file a complaint with the Italian Data Protection Authority or the supervisory authority of their country.'
            ],
            body2: [
                'To exercise these rights, write to info@foundly.it. A response will be provided within 30 days of the request.'
            ]
        },
        {
            title: '10. Legal basis for processing',
            bullets: [
                'Art. 6(1)(a) GDPR – Consent: for account creation via Google OAuth and non-technical cookies.',
                'Art. 6(1)(b) GDPR – Contract performance: to provide the music recommendation service and save favorites.',
                'Art. 6(1)(f) GDPR – Legitimate interest: for service security and abuse prevention.'
            ]
        },
        {
            title: '11. Cookies and tracking technologies',
            bullets: [
                'Technical cookies: necessary for application operation (session, language preferences).',
                'Google Analytics 4: with anonymized IP and advertising features disabled. Loaded only after user consent.',
                'localStorage and sessionStorage: to store preferences and session state client-side.',
                'Cookie banner: with "Accept", "Reject", and "Customize" options on first visit.'
            ]
        },
        {
            title: '12. International data transfers',
            body: [
                'Google data may be transferred to:'
            ],
            bullets: [
                'Google LLC (USA): for OAuth and Gemini API, in compliance with Standard Contractual Clauses approved by the European Commission.',
                'Supabase Inc. (EU servers): no extra-EU transfer for stored data.'
            ],
            body2: [
                'No transfers are made to third countries without adequate safeguards (Standard Contractual Clauses or adequacy decisions).'
            ]
        },
        {
            title: '13. Changes to this policy',
            body: [
                'This policy may be updated to comply with regulatory changes or the introduction of new features. The last update date is shown at the top of the page.',
                'Last updated: November 2025'
            ]
        }
    ]
};

export const getPrivacySections = (language = 'it') => privacyContent[language] || privacyContent.it;
